import { render, staticRenderFns } from "./CustomerShift.vue?vue&type=template&id=54b87c47&scoped=true&"
import script from "./CustomerShift.vue?vue&type=script&lang=js&"
export * from "./CustomerShift.vue?vue&type=script&lang=js&"
import style0 from "./CustomerShift.vue?vue&type=style&index=0&id=54b87c47&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b87c47",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VBtnToggle,VContainer,VLayout,VSpacer})
